/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';
import { MailMergeRecipient, MailMergeRecipientsSummary } from '@src/app/modules/agent/mail-merge.service';

export interface MailMergeRecipientsDialogData {
    title: string;
    recipients: MailMergeRecipient[];
    summary: MailMergeRecipientsSummary;
}

/**
 * A plain <table> rather than the app's grid component - a real HTML table copy-pastes cleanly
 * into Excel, which is exactly what this dialog is for; a virtualised/interactive grid would not.
 */
@Component({
    selector: 'app-mail-merge-recipients-dialog',
    templateUrl: './mail-merge-recipients-dialog.component.html',
    styleUrls: ['./mail-merge-recipients-dialog.component.scss'],
    imports: [DialogBannerComponent]
})
export class MailMergeRecipientsDialogComponent {
    dialogRef = inject<MatDialogRef<MailMergeRecipientsDialogComponent>>(MatDialogRef);
    data = inject<MailMergeRecipientsDialogData>(MAT_DIALOG_DATA);
}
